import { Reveal } from "../Reveal";

const FACTS = [
  { value: "65", label: "RV Sites" },
  { value: "30 & 50 Amp", label: "Service Available" },
  { value: "Open Year-Round", label: "Seasonal and Extended Stays" },
  { value: "Near Falcon Lake", label: "Fishing and Boating Access" },
] as const;

/** Verified property facts — values are always visible (no count-up delay). */
export function PropertyFacts() {
  return (
    <section
      className="border-y border-sand/60 bg-surface py-14 sm:py-16"
      aria-labelledby="property-facts-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <h2 id="property-facts-title" className="sr-only">
          Property facts
        </h2>
        <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {FACTS.map((fact, i) => (
            <Reveal as="li" key={fact.value} delay={i * 0.06} y={20}>
              <div className="rule-sand pt-5 lg:border-l lg:border-sand/60 lg:pl-6 lg:pt-0 lg:first:border-l-0 lg:first:pl-0">
                <p className="font-display text-2xl leading-tight text-forest-deep sm:text-[1.65rem]">
                  {fact.value}
                </p>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{fact.label}</p>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
